import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserRole, UserStatus } from 'src/app/core/models/auth.models';
import { AuthenticationService } from 'src/app/core/service/auth.service';
import { environment } from 'src/environments/environment';
import { ProjectStatus } from '../enums/project-enumm';
import { StatusProject } from '../models/project.model';

@Injectable({
  providedIn: 'root'
})
export class ProjectsServiceService {
  handleError: any;
  headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  constructor(private http: HttpClient,
    private auth: AuthenticationService,) {

  }

  

  tableSort(dragIndex: number, dropIndex: number, projectId: number) {
    /*On screen Start index=0*/
    dragIndex = dragIndex + 1;
    dropIndex = dropIndex + 1;
    return this.http.get<any>(environment.API_URL + `/api/projects/tableSort/${dragIndex}/${dropIndex}/${projectId}`);
  }

  getProjectsDrop() {
    let params = new HttpParams();
    params = params.appendAll({
      sort: 'createdAt:DESC',
    });

    return this.http.get<any>(environment.API_URL + `/api/projects`, { params });
  }
  getProjectsDropWSearch(search?:string) {
    let params = new HttpParams();
    params = params.appendAll({
      sort: 'createdAt:DESC',
      pageSize: 7,
      page: 1,
    });
    if (search) params = params.appendAll({
      searchFields: `name`,
      search
    });

    return this.http.get<any>(environment.API_URL + `/api/projects`, { params });
  }
  getProjectsByUserDrop(userId:number) {
    return this.http.get<any>(environment.API_URL + `/api/projects/user/${userId}`);
  }
  getAllProjectsForTable(pageSize: number, page: number, search?: string|null, filter?: any) {
    let params = new HttpParams();
    params = params.appendAll({
      pageSize,
      page,
      relations: 'customer,partner',
      sort: 'createdAt:DESC',
      'queryNot[status]': StatusProject.FINISHED
    });

    if (search) params = params.appendAll({
      searchFields: `name,partner.name,customer.name,createdAt,status`,
      search
    });
    if (filter) {
      if (filter.status && filter.status !== '') params = params.append('query[status]', filter.status);
      if (filter.partner && filter.partner !== '') params = params.append('query[partnerId]', filter.partner);
      if (filter.customer && filter.customer !== '') params = params.append('query[customerId]', filter.customer);
      if (filter.date && filter.date !== '') params = params.append('query[createdAt]', new Date(filter.date).toISOString());
    }

    return this.http.get<any>(environment.API_URL + `/api/projects`, { params });
  }
  getAllProjectsArchiveForTable(pageSize: number, page: number, search?: string, filter?: any) {
    let params = new HttpParams();
    params = params.appendAll({
      pageSize,
      page,
      relations: 'customer,partner',
      sort: 'createdAt:DESC'
    });

    if (search) params = params.appendAll({
      searchFields: `name,partner.name,customer.name,createdAt,status`,
      search
    });
    params = params.append('query[status]', StatusProject.FINISHED );
    if (filter) {
      if (filter.partner && filter.partner !== '') params = params.append('query[partnerId]', filter.partner);
      if (filter.customer && filter.customer !== '') params = params.append('query[customerId]', filter.customer);
      if (filter.date && filter.date !== '') params = params.append('query[createdAt]', new Date(filter.date).toISOString());
    }

    return this.http.get<any>(environment.API_URL + `/api/projects`, { params });
  }

  getPartners(search: any) {
    if (search) {
      return this.http.get<any>(environment.API_URL + `/api/companies?pageSize=7&page=1&search=${search}&searchFields=name&query[type]=PARTNER`);
    } else {
      return this.http.get<any>(environment.API_URL + `/api/companies?pageSize=7&page=1&query[type]=PARTNER`);
    }
  }

  getPartner(id: number) {
    return this.http.get<any>(environment.API_URL + `/api/companies?pageSize=1&page=1&query[type]=PARTNER&query[id]=${id}`);
  }

  getCustomers(id: number, search: any) {
    if (search) {
      return this.http.get<any>(environment.API_URL + `/api/companies/${id}/customers?pageSize=7&page=1&search=${search}&searchFields=name&query[type]=CUSTOMER`);
    } else {
      return this.http.get<any>(environment.API_URL + `/api/companies/${id}/customers?pageSize=7&page=1&query[type]=CUSTOMER`);
    }
  }

  createProject(project: any): any {
    return this.http.post<any>(environment.API_URL + '/api/projects', project, { headers: this.headers })
  }

  updateProject(project: any, id: number): any {
    return this.http.patch<any>(environment.API_URL + `/api/projects/${id}`, project, { headers: this.headers })
  }

  getProjectInfo(id: number) {
    return this.http.get<any>(environment.API_URL + `/api/projects/${id}?relations=uploadedFiles`);
  }

  /*2023.04.18@Rui Fernandes - processo inativo. Substituido por projectHide*/
  delete(idProject: number) {
    return this.http.delete(environment.API_URL + `/api/projects/${idProject}`)
  }

  projectHide(projectId: number) {
    return this.http.delete(environment.API_URL + `/api/projects/${projectId}`)
  }

  /* changeStatus */

  setFiled(id: number): any {
    const project= {status:ProjectStatus.FINISHED}
    return this.http.patch<any>(environment.API_URL + `/api/projects/${id}/status`, project, { headers: this.headers })
  }
  setSuspended(id: number): any {
    const project= {status:ProjectStatus.SUSPENDED}
    return this.http.patch<any>(environment.API_URL + `/api/projects/${id}/status`, project, { headers: this.headers })
  }
  setActive(id: number): any {
    const project= {status:ProjectStatus.PROCESS}
    return this.http.patch<any>(environment.API_URL + `/api/projects/${id}/status`, project, { headers: this.headers })
  }


  /*REQUIREMENTS */
  getRequirements(projectId: number, search?: string) {
    let params = new HttpParams();
    params = params.appendAll({
      pageSize: 7,
      page: 1,
      relations: 'group'
    });

    if (search && search !== '') {
      params = params.appendAll({
        searchFields: 'requirement',
        search
      });
    }

    return this.http.get<any>(environment.API_URL + `/api/projects/${projectId}/requirements`, { params });
  }


  getProjectMembers(projectId: number, search: string) { //@Get('projects/:id/teams/members')
    let params = new HttpParams();
    params = params.appendAll({
      pageSize: 7,
      page: 1,
    });


    if (search && search !== '') {
      params = params.appendAll({
        searchFields: 'firstName,lastName,email',
        search
      });
    }

    return this.http.get<any>(environment.API_URL + `/api/projects/${projectId}/teams/members`, { params });
  }


  /*Import data from Need,Requirement,Budget => UPPER CASE ! */
  importData(ImportType: string, JoinId: number, dataId: any) {
    return this.http.post<any>(environment.API_URL + `/api/projects/import/${ImportType.toUpperCase()}/${JoinId}`, { dataId });
  }


  


}
